<p-dialog
    [visible]="true"
    (visibleChange)="onCloseAction($event)"
    [closable]="true"
    [draggable]="false"
    [modal]="true"
    [style]="{'min-width': '35vw', 'width': '768px', 'max-width': '90vw'}"
>

<div *ngIf="videoFile" class="video-box position-relative w-100 h-100 text-center">
    <video style="inset:0;" [src]="videoFile" [attr.type]="mime" controls></video>
</div>

<div *ngIf="!videoFile" class="alert alert-warning">
    {{ 'Грешка при възпроизвеждане на видеото.' | transloco }}
</div>

</p-dialog>
